<div class="wow fadeIn"
     data-wow-duration="500ms">
   <div class="pageBanner about-mission"></div>

   <div class="page-sub-section font-16">
      <div class="contentBox line-25">
         <div class="sectionTitle margin-b-30 proximaNovaSb padding-b-20 border-bottom wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">Mission Holdings
         </div>
         <div class="margin-b-15 proximaNovaSb wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            Mission Holdings is the strategic investment vehicle for billionaire entrepreneur and investor Saurabh Mittal.
         </div>
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            We focus on being long-term investors in a concentrated portfolio of high-quality companies—ranging from active
            ownership through board-level partnerships to public market investments and select allocations via external managers.
         </div>
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            Total Assets (2024): ~$1.5 Bn
         </div>
         <div class=" wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            We are headquartered in Singapore and have offices in New York and Mumbai.
         </div>

      </div>
   </div>

   <div class="page-sub-section font-16 light-background">
      <div class="contentBox line-25">
         <div class="sectionTitle margin-b-30 proximaNovaSb padding-b-20 border-bottom wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="50ms">Our Approach
         </div>
         <div class="margin-b-15 proximaNovaSb wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            Mission Holdings prides itself in the exemplary leaders that we are partnered with.
         </div>
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            Mission Holdings believes in the power of long-term compounding and takes pride in the exemplary leaders with whom we
            partner. Our investment philosophy is inspired by the timeless principles of Warren Buffett—patient capital, aligned
            partnerships, and a commitment to enduring value creation.
         </div>
         <div class="margin-b-15 wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            We are a strategic, long-term partner to our entrepreneurs, supporting them in building industry-leading global
            businesses. As a principle, we do not seek control. Our core philosophy is one of co-creation—actively collaborating
            with our partners to ensure they retain control over their company’s destiny and direction. Our role is that of a
            strategic partner and facilitator.
         </div>
         <div class="margin-b-15  wow fadeInUp"
              data-wow-duration="500ms" data-wow-delay="150ms">
            The businesses we back maintain their own culture, organizational dynamics, independent leadership, and decision-making
            authority. We engage with them on capital allocation, long-term strategy, and solving critical business challenges.
         </div>
         <div class=" wow fadeInUp" data-wow-duration="500ms" data-wow-delay="150ms">
            Our partnership model begins with mutual trust and a shared belief in the leader’s unique fit with the opportunity—their
            ability to scale personally and to build a world-class team. We focus on large, long-term total addressable markets
            (TAMs) and invest in businesses positioned to benefit from disruptive trends that provide strong tailwinds for
            above-market growth.
         </div>

      </div>
   </div>

</div>
